// Notice For List
const noticeForList = [
    {
        id: 1,
        name: 'Service Provider',
        name_bn: 'সার্ভিস প্রদানকারী'
    },
    {
        id: 2,
        name: 'Service Receiver',
        name_bn: 'সার্ভিস গ্রহণকারী'
    }
]

// Notice For List
const archiveCurrentList = [
    {
        value: 1,
        text: 'Current',
        text_en: 'Current',
        text_bn: 'কারেন্ট'
    },
    {
        value: 2,
        text: 'Archive',
        text_en: 'Archive',
        text_bn: 'আর্কাইভ'
    }
]

// Status List
const statusList = [
    {
        id: 0,
        name: 'Pending',
        name_bn: 'প্রক্রিয়াধীন'
    },
    {
        id: 1,
        name: 'Processing',
        name_bn: 'প্রক্রিয়াজাতকরণ'
    },
    {
        id: 2,
        name: 'Presented',
        name_bn: 'উপস্থাপিত'
    },
    {
        id: 3,
        name: 'Rejected',
        name_bn: 'প্রত্যাখ্যাত'
    },
    {
        id: 4,
        name: 'Solved',
        name_bn: 'সমাধান হয়েছে'
    },
    {
        id: 5,
        name: 'Appealed',
        name_bn: 'আপিল করা হয়েছে'
    },
    {
        id: 6,
        name: 'Sent',
        name_bn: 'প্রেরণ করা হয়েছে'
    }
]
// Refundby List
const refundByList = [
    {
        id: 1,
        name: 'Bkash',
        name_bn: 'বিকাশ'
    },
    {
        id: 2,
        name: 'Rocket',
        name_bn: 'রকেট'
    },
    {
        id: 3,
        name: 'Bank',
        name_bn: 'ব্যাংক'
    },
    {
        id: 4,
        name: 'Cash',
        name_bn: 'নগদ'
    }
]

// Report Types List
const reportTypes = [
    {
        value: 1,
        text: 'LLP',
        text_bn: 'এলএলপি'
    },
    {
        value: 2,
        text: 'Deep Tubewell',
        text_bn: 'গভীর নলকূপ'
    },
    {
        value: 3,
        text: 'Final Report',
        text_bn: 'চূড়ান্ত প্রতিবেদন'
    },
    {
        value: 4,
        text: 'Irrigation Machine and Irrigation Areas',
        text_bn: 'সেচযন্ত্র ও সেচ এলাকা'
    }
]
// Form Types List
const formTypes = [
    {
        value: 1,
        text: 'KO',
        text_bn: 'ক'
    },
    {
        value: 2,
        text: 'KHA',
        text_bn: 'খ'
    },
    {
        value: 3,
        text: 'GA',
        text_bn: 'গ'
    },
    {
        value: 4,
        text: 'GHA',
        text_bn: 'ঘ'
    },
    {
        value: 5,
        text: 'UMO',
        text_bn: '‘ঙ’'
    }
]

const maritalStatus = [
    {
        value: 1,
        text: 'Married',
        text_en: 'Married',
        text_bn: 'বিবাহিত'
    },
    {
        value: 2,
        text: 'Single',
        text_en: 'Single',
        text_bn: 'অবিবাহিত'
    },
    {
        value: 3,
        text: 'Divorced',
        text_en: 'Divorced',
        text_bn: 'তালাকপ্রাপ্ত'
    }
]

const genderList = [
    {
        value: 1,
        text_en: 'Male',
        text_bn: 'পুরুষ'
    },
    {
        value: 2,
        text_en: 'Female',
        text_bn: 'মহিলা'
    },
    {
        value: 3,
        text_en: '3rd Gender',
        text_bn: '৩য় লিঙ্গ'
    }
]
const genderListEx = [
    {
        value: 1,
        text_en: 'Male',
        text_bn: 'পুরুষ'
    },
    {
        value: 2,
        text_en: 'Female',
        text_bn: 'মহিলা'
    }
]

const instituteTypeList = [
    {
        value: 1,
        text_en: 'Boy',
        text_bn: 'ছেলে'
    },
    {
        value: 2,
        text_en: 'Girl',
        text_bn: 'মেয়ে'
    },
    {
        value: 3,
        text_en: 'Both (Boy & Girl)',
        text_bn: 'উভয়ই (ছেলে ও মেয়ে)'
    }
]

const beneficiaryAccountType = [
    {
        value: 1,
        text_en: 'Bank Account',
        text_bn: 'ব্যাংক হিসাব'
    },
    {
        value: 2,
        text_en: 'Mobile Banking',
        text_bn: 'মোবাইল ব্যাংকিং'
    }
]

const bankAccountType = [
    {
        value: 1,
        text_en: 'Current Account',
        text_bn: 'চলতি হিসাব'
    },
    {
        value: 2,
        text_en: 'Saving Account',
        text_bn: 'সঞ্চয়ী হিসাব'
    }
]

const mfsService = [
    {
        value: 1,
        text_en: 'Bkash',
        text_bn: 'বিকাশ'
    },
    {
        value: 2,
        text_en: 'Rocket',
        text_bn: 'রকেট'
    },
    {
        value: 3,
        text_en: 'Nagad',
        text_bn: 'নগদ'
    }
]

const answerList = [
    {
        value: 1,
        text_en: 'Yes',
        text_bn: 'হ্যাঁ'
    },
    {
        value: 0,
        text_en: 'No',
        text_bn: 'না'
    }
]
const modeList = [
    {
        value: 1,
        text_en: 'Online',
        text_bn: 'অনলাইন'
    },
    {
        value: 2,
        text_en: 'Offline',
        text_bn: 'অফলাইন'
    }
]

const applicationTypeList = [
    {
        value: 1,
        text_en: 'New',
        text_bn: 'নতুন'
    },
    {
        value: 2,
        text_en: 'Quota Extension',
        text_bn: 'কোটা সম্প্রসারণ'
    },
    {
        value: 3,
        text_en: 'Quota Replacement',
        text_bn: 'কোটা প্রতিস্থাপন'
    }
]
const directoryTypeList = [
    {
        id: 1,
        name: 'Dealer',
        name_bn: 'ব্যবসায়ী'
    },
    {
        id: 2,
        name: 'Shop',
        name_bn: 'দোকান'
    },
    {
        id: 3,
        name: 'machine',
        name_bn: 'যন্ত্র'
    }
]

const wardTypeList = [
    {
        id: 1,
        name: 'City Corporation',
        name_bn: 'সিটি কর্পোরেশন'
    },
    {
        id: 2,
        name: 'Pauroshoba',
        name_bn: 'পৌরসভা'
    },
    {
        id: 3,
        name: 'Upazila',
        name_bn: 'উপজেলা'
    }
]

const activeIntactive = [
    {
        value: 0,
        name: 'Active',
        name_bn: 'সক্রিয়'
    },
    {
        value: 1,
        name: 'Inactive',
        name_bn: 'নিষ্ক্রিয়'
    }
]

const campaignTypeList = [
    {
        value: 1,
        text: 'Admin',
        text_bn: 'প্রশাসন'
    },
    {
        value: 2,
        text: 'Request',
        text_bn: 'অনুরোধ'
    },
    {
        value: 3,
        text: 'Divisional Head',
        text_bn: 'বিভাগীয় প্রধান'
    }
]

const patientTypeList = [
    {
        value: 1,
        text_en: 'Registred',
        text_bn: 'নিবন্ধিত'
    },
    {
        value: 2,
        text_en: 'New',
        text_bn: 'নতুন'
    }
]

const religionList = [
    { value: 1, text_en: 'Muslim', text_bn: 'মুসলিম' },
    { value: 2, text_en: 'Hinduism', text_bn: 'হিন্দু' },
    { value: 3, text_en: 'Buddhism', text_bn: 'বৌদ্ধ' },
    { value: 4, text_en: 'Christianity', text_bn: 'খ্রিষ্টান' },
    { value: 5, text_en: 'Other', text_bn: 'অন্যান্য' }
]

const buttonTypeList = [
    {
        value: 1,
        text: 'Pending',
        text_en: 'Pending',
        text_bn: 'প্রক্রিয়াধীন'
    },
    {
        value: 2,
        text: 'Processing',
        text_en: 'Processing',
        text_bn: 'প্রক্রিয়াধীন'
    },
    {
        value: 3,
        text: 'Approved',
        text_en: 'Approved',
        text_bn: 'অনুমোদন'
    },
    {
        value: 4,
        text: 'Reject',
        text_en: 'Reject',
        text_bn: 'প্রত্যাখ্যান'
    },
    {
        value: 5,
        text: 'Send',
        text_en: 'Send',
        text_bn: 'পাঠান'
    },
    {
        value: 6,
        text: 'Forward',
        text_en: 'Forward',
        text_bn: 'ফরোয়ার্ড'
    },
    {
        value: 7,
        text: 'Receive',
        text_en: 'Receive',
        text_bn: 'প্রাপ্তি'
    },
    {
        value: 8,
        text: 'Application',
        text_en: 'Application',
        text_bn: 'আবেদন'
    },
    {
        value: 9,
        text: 'Assign',
        text_en: 'Assign',
        text_bn: 'বরাদ্দ'
    }
]

const mediaList = [
    {
        value: 1,
        text: 'Mobile',
        text_en: 'Mobile',
        text_bn: 'মোবাইল'
    },
    {
        value: 2,
        text: 'Email',
        text_en: 'Email',
        text_bn: 'ইমেইল'
    },
    {
        value: 3,
        text: 'Web',
        text_en: 'Web',
        text_bn: 'ওয়েব'
    }
]

const recipientList = [
    {
        value: 1,
        text: 'Sender',
        text_en: 'Sender',
        text_bn: 'প্রেরক'
    },
    {
        value: 2,
        text: 'Receiver',
        text_en: 'Receiver',
        text_bn: 'প্রাপক'
    }
]

const facilityList = [
    {
        value: 1,
        text: 'Personal',
        text_en: 'Personal',
        text_bn: 'নিজস্ব'
    },
    {
        value: 2,
        text: 'By Donation or Purchase',
        text_en: 'By Donation or Purchase',
        text_bn: 'দান বা ক্রয়সুত্রে'
    },
    {
        value: 3,
        text: 'Other',
        text_en: 'Other',
        text_bn: 'অন্যান্য'
    }
]

const monthList = [
    {
        value: 1,
        text_en: 'January',
        text_bn: 'জানুয়ারী'
    },
    {
        value: 2,
        text_en: 'February',
        text_bn: 'ফেব্রুয়ারী'
    },
    {
        value: 3,
        text_en: 'March',
        text_bn: 'মার্চ'
    },
    {
        value: 4,
        text_en: 'April',
        text_bn: 'এপ্রিল'
    },
    {
        value: 5,
        text_en: 'May',
        text_bn: 'মে'
    },
    {
        value: 6,
        text_en: 'June',
        text_bn: 'জুন'
    },
    {
        value: 7,
        text_en: 'July',
        text_bn: 'জুলাই'
    },
    {
        value: 8,
        text_en: 'August',
        text_bn: 'আগস্ট'
    },
    {
        value: 9,
        text_en: 'September',
        text_bn: 'সেপ্টেম্বর'
    },
    {
        value: 10,
        text_en: 'October',
        text_bn: 'অক্টোবর'
    },
    {
        value: 11,
        text_en: 'November',
        text_bn: 'নভেম্বর'
    },
    {
        value: 12,
        text_en: 'December',
        text_bn: 'ডিসেম্বর'
    }
]

const registrationIdType = [
    { value: 1, text_en: 'Reigtration ID', text_bn: 'রিজিট্রেশন আইডি' },
    { value: 2, text_en: 'NID', text_bn: 'এনআইডি' },
    { value: 3, text_en: 'Birth ID', text_bn: 'জন্ম সনদ আইডি' },
    { value: 4, text_en: 'DSS ID', text_bn: 'ডিএসএস আইডি' }
    // { value: 4, text_en: 'DIS ID', text_bn: 'ডিআইএস' }

  ]
const recomendedRadioBtn = [
    { value: 1, text_en: 'Yes', text_bn: 'হ্যাঁ' },
    { value: 0, text_en: 'No', text_bn: 'না' }
]

const bloodGroupList = [
    { value: 1, text_en: 'A+', text_bn: 'এ+' },
    { value: 2, text_en: 'A-', text_bn: 'এ-' },
    { value: 3, text_en: 'B+', text_bn: 'বি+' },
    { value: 4, text_en: 'B-', text_bn: 'বি-' },
    { value: 5, text_en: 'O+', text_bn: 'ও+' },
    { value: 6, text_en: 'O-', text_bn: 'ও-' },
    { value: 7, text_en: 'AB+', text_bn: 'এবি+' },
    { value: 8, text_en: 'AB-', text_bn: 'এবি-' }
]

const subOccupationList = [
    {
        value: 1,
        text_en: 'Blacksmith',
        text_bn: 'কামার'
    },
    {
        value: 2,
        text_en: 'Potter',
        text_bn: 'কুমার'
    },
    {
        value: 3,
        text_en: 'Barber',
        text_bn: 'নাপিত'
    },
    {
        value: 4,
        text_en: 'Bamboo & Cane Workers',
        text_bn: 'বাঁশ ও বেত শ্রমিক'
    },
    {
        value: 5,
        text_en: 'Cobbler',
        text_bn: 'মুচি'
    },
    {
        value: 6,
        text_en: 'Farmer',
        text_bn: 'কৃষক'
    },
    {
        value: 7,
        text_en: 'Fishermen',
        text_bn: 'জেলে'
    },
    {
        value: 8,
        text_en: 'Day Labourer',
        text_bn: 'দিনমজুর'
    },
    {
        value: 9,
        text_en: 'Weaver',
        text_bn: 'তাঁতি'
    },
    {
        value: 10,
        text_en: 'Porter',
        text_bn: 'কুলি'
    },
    {
        value: 11,
        text_en: 'Housewife',
        text_bn: 'গৃহিণী'
    },
    {
        value: 12,
        text_en: 'Others',
        text_bn: 'অন্যান্য'
    }
]

export default {
    activeIntactive,
    statusList,
    refundByList,
    reportTypes,
    formTypes,
    maritalStatus,
    genderList,
    genderListEx,
    wardTypeList,
    campaignTypeList,
    directoryTypeList,
    noticeForList,
    archiveCurrentList,
    patientTypeList,
    instituteTypeList,
    applicationTypeList,
    answerList,
    modeList,
    beneficiaryAccountType,
    bankAccountType,
    mfsService,
    religionList,
    registrationIdType,
    monthList,
    buttonTypeList,
    recipientList,
    mediaList,
    recomendedRadioBtn,
    bloodGroupList,
    subOccupationList,
    facilityList
}
